import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'

export type DocumentTypeProps = ModelProps<DocumentType>

/**
 * The user type that will be uploading the document.
 */
export type UploaderUserType = 'Client' | 'Pro'

/**
 * All well-known document type IDs as an array.
 */
export const allWellKnownDocumentTypeIds = [
  'FINAL_RETURN',
  'DRAFT_RETURN',
  'EXTENSION_CONFIRMATION',
  'E_FILE_CONFIRMATION',
  'PRIOR_YEAR_RETURN',
  'ID',
  'ANNOTATED_SOURCE_DOCUMENT',
  'UNKNOWN',
  'PREP_NOTES',
  'REVIEW_NOTES',
  'GENERATED_TRANSCRIPT',
] as const

/**
 * Map of known document type short IDs.
 */
export type WellKnownDocumentTypeId =
  (typeof allWellKnownDocumentTypeIds)[number]

/**
 * Type describing the potential contents of a document.
 */
export class DocumentType extends Model<DocumentType> {
  /**
   * Short ID of the document type.
   */
  id = Id.none

  @observable accessor name = ''
  @observable accessor imageUrl: string | null = ''
}
